import { Component } from '@angular/core';
import * as Models from '../../models/login';
import * as Interfaces from '../../interfaces/login';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginResponse } from '../../interfaces/login-response';
import * as Setting from '../../../../assets/settings.json';
import { LoggerService } from 'src/app/services/logger.service';
import { UserApiService } from 'src/app/dashboard/services/user-api.service';
import { TranslateService } from '@ngx-translate/core';
import { LastActivePageService } from 'src/app/services/last-active-page.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent {
  cookieService: any;

  public constructor(
    public logger: LoggerService,
    private lastActivePageService: LastActivePageService,
    private apiService: UserApiService,
    private translate: TranslateService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.submitted = false;
    localStorage.removeItem('id_token');
    localStorage.removeItem('userId');
    localStorage.removeItem('roleIds');
    localStorage.removeItem('isAdmin');
    localStorage.removeItem('userName');
    this.login = new Models.Login();
    this.passwordIsShow = `password`;
  }

  public passwordIsShow: string;
  public submitted: boolean;
  public login: Interfaces.Login;
  public loginResponse?: LoginResponse;

  public thisCulture: any;
  public data: any = Setting;

  public onSubmit(): void {
    this.submitted = true;

    this.apiService.getToken(this.login).subscribe(
      (result) => {
        if (!result.succeeded) {
          for (let index = 0; index < result.errorMessages.length; index++) {
            const element = result.errorMessages[index];
            this.logger.addError(element, false);
          }
        } else {
          this.loginResponse = result;
          localStorage.setItem('id_token', this.loginResponse.data.token);
          localStorage.setItem('isAdmin', 'true');

          const redirectPage = 
                this.lastActivePageService.getLastActivePage();
          if (redirectPage == null||redirectPage.indexOf('login')>=0) {
            this.router.navigate(['home']);
          } else {
            {
              this.router.navigate([redirectPage]);
            }
          }
        }

        this.submitted = false;
      },
      (error) => {
        this.apiService.AddErrorLog(error);
        this.submitted = false;
      },
      () => {
        this.submitted = false;
      }
    );
  }

  public changeCulture(language: string) {
    this.translate.use(language);
    this.thisCulture = this.data.culture.filter(
      (current) => current.shorCode === language
    )[0];

    var htmlTag = document.getElementsByTagName('html')[0];
    if (this.thisCulture.IsRightToLeft) {
      htmlTag.setAttribute('dir', 'rtl');
    } else {
      htmlTag.setAttribute('dir', 'ltr');
    }
    this.cookieService.set('Culture', this.thisCulture.languageCultureName);
  }

  public changePasswordState() {
    if (this.passwordIsShow == `password`) {
      this.passwordIsShow = `text`;
    } else {
      this.passwordIsShow = `password`;
    }
  }
}
